// /web/src/components/PricingTierCards.jsx
import React from "react";

export default function PricingTierCards({ tiers, onTierSelect }) {
  return (
    <div className="pd-pricing">
      {tiers.map((tier) => (
        <article
          key={tier.name}
          className={`pd-price ${tier.featured ? "is-featured" : ""}`.trim()}
        >
          <h3 className="pd-h3">{tier.name}</h3>
          <div className="pd-price__value">
            <span className="pd-price__amount">{tier.price}</span>
            <span className="pd-muted">{tier.meta}</span>
          </div>

          <button
            type="button"
            className={`pd-btn ${tier.featured ? "pd-btn--primary" : "pd-btn--ghost"}`}
            onClick={() => onTierSelect?.(tier)}
          >
            {tier.cta}
          </button>

          <p className="pd-muted pd-price__desc">{tier.desc}</p>

          <hr className="pd-divider" />

          <ul>
            {tier.perks.map((perk) => (
              <li key={perk.text} className="pd-perk">
                {perk.text}
                {perk.tooltip ? (
                  <span className="pd-info" title={perk.tooltip}>
                    i
                  </span>
                ) : null}
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  );
}
